
export type ConnectDialogType =  'SUCCESS' | 'WARNING' | 'INFORMATION' | 'ERROR' ;
export class ConnectDialog {
    message : string;
    title : string;
    dialogType : ConnectDialogType;
    header : string
    showCancelBtn : boolean = true
    showInputText : boolean = false
    inputLabel: string
    notes: string;
    okBtnText : string = 'OK';
    cancelBtnText : string = 'Cancel';
    showTextArea: boolean = false;
    textAreaText: string;
    textAreaLabel: string;
}
